import React, { useEffect, useState } from "react";
import style from "../solo.module.sass";
import { Select, Input, Icon, Button, Tooltip } from 'antd';
import dragIcon from "../../../../../assets/svg/drag_icon.svg";
import _ from "lodash";
import CodeEditor from "../codeEditor/CodeEditor"
import { ReactSortable } from "react-sortablejs";
import AclEventNodeDrawer from "./AclEventNodeDrawer";
const { Option } = Select;

const Event = (props: any) => {/* eslint-disable */
    const { elements, nodeDetail, widgetDrawer } = props;
    const [sortableOptions, setSortableOptions] = useState({
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        ghostClass: "ghost",
        group: "shared",
        disabled: false,
        handle: ".drag-handle"
    });
    const [eventName, setEventName]: any = useState("")
    const [spaceKeyPressed, setSpaceKeyPressed]: any = useState(false)
    const [reactSortableKey, setReactSortableKey]: any = useState(new Date().getTime());
    const [addHandle, setAddHandle]: any = useState(0);
    const [addEvent, setAddEvent]: any = useState([{
        id: "",
        handler: "",
        Name: "",
        linkNode: "",
        nameCheck: false,
        blocks: false,
        expand: false,
    }])
    const [nodes, setNodes]: any = useState(null)
    const [name, setName]: any = useState(null);
    const [eventProperty, setEventProperty]: any = useState({ nodeId: null })
    const [removeEvent, setRemoveEvent]: any = useState(0)
    const [removedLinkNode, setRemovedLinkNode]: any = useState(null);
    const [modalOpen, setmodelOpen]: any = useState(false)
    const [handleId, setHandleId]: any = useState(null)
    const [updatedId, setUpdatedId]: any = useState(null)
    const [showCheckIcon, setShowCheckIcon]: any = useState(false)
    const [showaddIcon, setShowAddIcon]: any = useState(false)
    const [value, setValue]: any = useState(null)
    const [showEdit, setshowEdit] = useState(true)
    const [toggle, setToggleEnable]: any = useState(false)
    const [expandAll, setExpandAll]: any = useState(false);
    const [disableExpand, setDisableExpand]: any = useState(true)
    const [removeValues, setRemoveValues]: any = useState(false)
    const [editEnable, setEditEnable]: any = useState(false)
    const [eventNameEmpty, setEventNameEmpty] = useState(false)
    const eventsName = [{ id: "resume", name: "Resume" }, { id: "expiry", name: "Expiry" }, { id: "idle", name: "Idle" }]
    const [eventNodeDrawer,setEventNodeDrawer] = useState(false)

    useEffect(() => {
        const findNodes = elements.map((el: any) => {
            if(nodeDetail?.data?.propertyDetails?.name !== "Resume event" && !el.source){
                if(el?.data?.type === "service"){
                    return el
                }
            } else if (el?.data?.type !== "start" && el?.data?.type !== "error" && el?.data?.type !== "event" && el.id !== nodeDetail.id && !el.source) {
                return el
            }
        }).filter((el: any) => {return el})
        setNodes(findNodes)
    }, [elements])

    useEffect(() => {
        if (value && value.length > 0) {
            setShowCheckIcon(true)
        } else {
            setShowCheckIcon(false)
        }
    }, [value])

    useEffect(()=>{
        if (nodeDetail.type === "event" && props.flowDetail && props.flowDetail.source && props.flowDetail.source.nodes){
           let {componentAcl = {}} =  props.flowDetail.source?.nodes.find((e:any)=> e.id === nodeDetail.id) || {}
           setEventProperty({
                ...eventProperty,
                componentAcl
            })
        }
    },[])

    useEffect(() => {
        let arr: any = [];
        let obj: any = {};
        if (addEvent.length > 0) {
            const findSourceHandle = elements.map((el: any) => {
                if (el.hasOwnProperty("sourceHandle")) {
                    return { sourceHandle: el.sourceHandle, source: el.source, target: el.target };
                } else {
                    return ""
                }
            }).filter((el: any) => el)

            addEvent.forEach((el: any) => {
                const element = findSourceHandle.filter((element: any) => { return element.sourceHandle === el.id && element.source === nodeDetail.id })
                let findElement: any;
                if (element.length > 0) {
                    element.forEach((e: any) => {
                        findElement = elements.filter((el: any) => { return el.id === e.target && e.source === nodeDetail.id })
                    })
                }
                if (findElement && findElement.length > 0) {
                    obj = {
                        ...el,
                        linkNode: findElement[0].id
                    }
                    arr.push(obj);
                } else {
                    obj = {
                        ...el,
                        linkNode: findElement?.length === 0 ? el.linkNode : ""
                    }
                    arr.push(obj)
                }
            })
        }
        arr.length > 0 && setAddEvent(arr)
    }, [elements])

    useEffect(() => {
        if (nodeDetail && nodeDetail.data.propertyDetails) {
            if (nodeDetail.type === "event") {
                if (nodeDetail.data.propertyDetails.events) {
                    let arr: any = [];
                    let obj: any = {};
                    setEventName(nodeDetail.data.propertyDetails.eventName)
                    setName(nodeDetail.data.propertyDetails.name);
                    setDisableExpand(false)
                    for (const element of elements) {
                        for (const event of nodeDetail.data.propertyDetails.events) {
                            if (element.source === nodeDetail.id && element.sourceHandle === event.id) {
                                const nextNode = elements.filter((el: any) => { return (element.target === el.id) })
                                obj = {
                                    id: event.id,
                                    Name: event.Name,
                                    handler: event.handler,
                                    linkNode: element.target,
                                    blocks: event.blocks,
                                    nameCheck: event.nameCheck,
                                    expand: event.expand && event.expand
                                }
                                if (arr.length > 0) {
                                    if (!arr.some((element: any) => element.id === obj.id)) {
                                        arr.push(obj);
                                    } else if (element.source === nodeDetail.id && element.sourceHandle === event.id && event.linkNode === "") {
                                        let value = arr.filter((ele: any) => {
                                            return ele.id === event.id
                                        })
                                        value.map((val: any) => {
                                            val.linkNode = element.target;
                                        })
                                    }
                                } else {
                                    arr.push(obj);
                                }
                            } else if (event.linkNode === "" && element.source !== nodeDetail.id && element.sourceHandle === undefined) {
                                obj = {
                                    id: event.id,
                                    Name: event.Name,
                                    handler: event.handler,
                                    linkNode: event.linkNode,
                                    blocks: event.blocks,
                                    nameCheck: event.nameCheck,
                                    expand: event.expand && event.expand
                                }
                                if (arr.length > 0) {
                                    if (!arr.some((element: any) => element.id === obj.id)) {
                                        arr.push(obj);
                                    }
                                }
                                else {
                                    arr.push(obj);
                                }
                            } else {
                                const node = elements.filter((el: any) => { return el.source === nodeDetail.id && el.target === event.linkNode })
                                obj = {
                                    id: event.id,
                                    Name: event.Name,
                                    handler: event.handler,
                                    linkNode: node.length > 0 ? event.linkNode : "",
                                    blocks: event.blocks,
                                    nameCheck: event.nameCheck,
                                    expand: event.expand && event.expand
                                }
                                if (arr.length > 0) {
                                    if (!arr.some((element: any) => element.id === obj.id)) {
                                        arr.push(obj);
                                    }
                                }
                                else {
                                    arr.push(obj);
                                }
                            }
                        }
                    }
                    arr.length && setAddEvent(arr)
                    setRemoveValues(false)
                    setEditEnable(false)
                    setShowAddIcon(true)
                    setEventNameEmpty(false)
                } else {
                    if (nodeDetail.type === "event") {
                        setName(nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.name);
                        setEventName(nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.eventName);
                        let eventData: any = []
                        let events: any = {}
                        let node: any;
                        let id = 0;
                        nodeDetail.data.propertyDetails && nodeDetail.data.propertyDetails.eventHandler && nodeDetail.data.propertyDetails.eventHandler.map((c: any) => {
                            id = id + 1
                            elements.map((e: any) => {
                                if (c.next.type === "end") {
                                    if (e.data && e.data.type && (e.data.type === "stop" || e.data.type === "return")) {
                                        node = e.id;
                                    }
                                } else if (e.source === nodeDetail.id && e.sourceHandle === _.camelCase(c.name)) {
                                    node =  e.target;
                                }
                                return node
                            })
                            events = {
                                ...events,
                                id: _.camelCase(c.name),
                                handler: c.handler,
                                Name: c.name,
                                linkNode: node,
                                blocks: true,
                                nameCheck: false,
                                expand: false,
                            }
                            node = "";
                            return eventData.push(events)
                        })
                        if (eventData) {
                            setEventNameEmpty(false)
                            setRemoveValues(false)
                            setDisableExpand(false);
                            setEditEnable(false)
                            setAddEvent(eventData)
                            setShowCheckIcon(false)
                            setShowAddIcon(true)
                        }
                    }
                }
            }
        } else if (!nodeDetail.data.propertyDetails) {
            if (nodeDetail.type === "event") {
                const findEventNodes = elements.filter((el: any) => {return el.type === "event"})
                let eventName: any = [];
                if(findEventNodes.length > 0){
                    eventName = findEventNodes.map((el: any) => {
                        let events = ["resume", "expiry", "idle"]
                        if(events.includes(el?.data?.propertyDetails?.eventName) && nodeDetail.id !== el.id) {
                            return el?.data?.propertyDetails?.eventName
                        }
                    }).filter((e: any) => e)
                }
                const findName = eventsName.map((el: any) => { 
                    if(!eventName.includes(el.id)){
                        return el
                    }
                }).filter((el: any) => {return el})
                setName(findName.length > 0 ? findName[0].name + " " +"event" : "Resume event")
                setEventName(findName.length > 0 ? findName[0].name : "Resume");
                setAddEvent([{
                    id: "",
                    handler: "",
                    Name: "",
                    linkNode: "",
                    nameCheck: false,
                    blocks: false,
                    expand: false,
                }])
                setEventNameEmpty(false)
                setAddHandle(addHandle + 1);
                setEditEnable(false)
                setRemoveValues(false)
                setDisableExpand(false)
                setEditEnable(false)
                setShowCheckIcon(false)
            }
        }
    }, [nodeDetail.id])

    useEffect(() => {
        if (eventName) {
            let newEventName = eventName.split(" ")[0] || ""
            setEventProperty({
                ...eventProperty,
                nodeId: props.nodeDetail.id,
                eventName: newEventName.toLowerCase(),
                name: name,
                idChange: false,
                events: addEvent,
                type: "event"
            })
        }
    }, [eventName])
    

    const setAclProperties = ((aclData:any)=>{
        setEventProperty({
            ...eventProperty,
            idChange:true,
            componentAcl:{...aclData}
        })
    })


    useEffect(() => {
        if (addEvent.length > 0) {
            if (addEvent.every((eL: any) => eL.expand === true)) {
                setExpandAll(true)
            } else {
                setExpandAll(false)
            }
        }
    }, [addEvent])


    useEffect(() => {
        props.onUpdateProperties(eventProperty)
    }, [eventProperty])

    useEffect(() => {
        if (removeEvent > 0) {
            let newEventName = "";
            if(eventName){
                newEventName = eventName.split(" ")[0]
            }
            setEventProperty({
                ...eventProperty,
                nodeId: nodeDetail.id,
                events: addEvent,
                eventName: newEventName.toLowerCase(),
                name: name,
                idChange: true,
                removedLinkNode: removedLinkNode,
                handleId: handleId
            })
        }
    }, [removeEvent])

    useEffect(() => {
        if (addHandle > 0) {
            let newEventName = "";
            if (eventName) {
                newEventName = eventName.split(" ")[0]
            }
            if (!updatedId) {
                setEventProperty({
                    ...eventProperty,
                    nodeId: nodeDetail.id,
                    events: addEvent,
                    name: name,
                    eventName: newEventName.toLowerCase(),
                    idChange: true,
                })
            } else if (updatedId) {
                setEventProperty({
                    ...eventProperty,
                    nodeId: props.nodeDetail.id,
                    eventName: newEventName.toLowerCase(),
                    events: addEvent,
                    name: name,
                    idChange: true,
                    updatedId: updatedId && updatedId
                })
            }
        }
    }, [addHandle])

    const AddHandle = () => {
        const value = {
            id: "",
            handler: "",
            Name: "",
            linkNode: "",
            blocks: false,
            nameCheck: false,
            expand: false
        }
        setAddEvent((prevState: any) => [value, ...prevState]);
    }

    const eventHandler = (i: any, value: any) => {
        const values = [...addEvent];
        values[i].handler = value;
        setAddEvent(values);
    }

    const handleSpace = (e: any) => {
        if (e.keyCode === 32 || e.keyCode === 8) {
            setSpaceKeyPressed(true)
        } else {
            setSpaceKeyPressed(false)
        }
    };

    const handleName = (e: any, Index: any) => {
        const { value } = e.target;
        setValue(value);
        const Names = addEvent.map((el: any) => _.camelCase(el.Name));
        setEventNameEmpty(false)
        if (Names) {
            if (Names.splice(0, Names.length + 1).includes(_.camelCase(e.target.value)) && !spaceKeyPressed) {
                const val = [...addEvent]
                val[Index].nameCheck = true;
                val[Index].Name = e.target.value;
                setAddEvent(val)
                setShowCheckIcon(false)
            } else {
                const values = [...addEvent];
                values[Index].Name = e.target.value;
                values[Index].nameCheck = false;
                values[Index].id = _.camelCase(e.target.value)
                setAddEvent(values);
            }
        } else {
            const values = [...addEvent];
            values[Index].Name = e.target.value;
            values[Index].nameCheck = false;
            values[Index].id = _.camelCase(e.target.value)
            setAddEvent(values);
        }
    }

    const linkNode = (e: any, Index: any) => {
        const values = [...addEvent];
        values[Index].linkNode = e;
        setAddEvent(values);
    }

    const handleRemove = (i: any = null, id: any = null) => {
        if (i !== undefined && !id) {
            const values = [...addEvent];
            values.splice(i, 1);
            setAddEvent(values);
        } else if (i !== undefined && id) {
            addEvent.forEach((c: any) => {
                if (c.id === id) {
                    setHandleId(c.id)
                    setRemovedLinkNode(c.linkNode)
                }
            })
            setAddEvent((prevState: any) => prevState.filter((i: any) => { return i.id !== id }))
            setRemoveEvent(removeEvent + 1);
        }
    }

    const findhandleId = (i: any, id: any) => {
        let updatedId = addEvent.filter((m: any) => {
            return (m.id === id);
        })
        updatedId && updatedId.map((i: any) => {
            return setUpdatedId(i.id)
        })
    }

    const openModal = () => {
        setmodelOpen(true)
    }

    const closeModal = () => {
        setmodelOpen(false)
    }

    const renderEvents = (index: number, element: any, blocks: any, expand: any) => {
        const checkSpecialCharacter = /[!@#$%^&*~`()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        return (
            <div key={index + 1} style={{ padding: "0 10px" }}>
                {!expand && blocks &&
                    <div className={style.collapsePanel} >
                        <div
                            style={{ display: "flex", flexDirection: "row" }}
                        >
                            {blocks && !props.lock && showaddIcon && addEvent.length > 1 &&
                                <img
                                    className={element.Name === "Default" ? "filtered" : "drag-handle"}
                                    style={{ height: "25px", width: 10, cursor: "move" }}
                                    onClick={() => element.Name !== "Default" && setToggleEnable(true)}
                                    src={element.Name !== "Default" ? dragIcon : ""}
                                />}
                            <Tooltip title={element.Name}>
                                <div className={style.panelName}>
                                    {element.Name}
                                </div>
                            </Tooltip>
                        </div>
                        {!props.lock &&
                            <div style={{ display: "flex", alignItems: "center" }}>
                                {!removeValues && !editEnable && showaddIcon && <Icon
                                    type="edit"
                                    style={{ marginRight: "10px", fontSize: 15 }}
                                    onClick={() => {
                                        setAddEvent(
                                            (condition: any) => condition.map((c: any) => {
                                                return c.id === element.id ? { ...element, blocks: false } : c
                                            }));
                                        findhandleId(index, element.id);
                                        setShowAddIcon(false)
                                        setShowCheckIcon(true)
                                        setshowEdit(false)
                                        setRemoveValues(true)
                                    }} />}
                                {element.Name !== "Default" && showaddIcon && <Icon
                                    type="delete"
                                    style={{ marginRight: "10px", fontSize: 15 }}
                                    onClick={() => handleRemove(index, element.id)}
                                ></Icon>}
                                {showaddIcon && <Icon
                                    style={{ fontSize: 15, marginRight: "10px" }}
                                    type="right"
                                    onClick={() => {
                                        setAddEvent(
                                            (condition: any) => condition.map((c: any) => {
                                                return c.id === element.id ? { ...element, expand: true } : c
                                            }))

                                    }} >
                                </Icon>}
                            </div>}
                    </div>}

                {(!blocks || expand) &&
                    <div
                        style={{
                            border: (expand || expandAll || !showEdit) ? "1px solid #CAD5E9" : "",
                            background: (expand || expandAll || !showEdit) ? "#FFFFFF 0% 0% no-repeat padding-box" : "",
                            boxShadow: (expand || expandAll || !showEdit) && "0px 3px 14px #CAD5E983",
                            marginTop: "20px",
                            borderRadius: "5px"
                        }}>
                        {(expand || expandAll || !showEdit && !props.lock) &&
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                padding: (expand || expandAll || !showEdit) ? "0px 10px" : "0px 20px",
                                position: (expand || expandAll || !showEdit) && "relative",
                                marginTop: (expand || expandAll || !showEdit) && "10px"
                            }}>
                                {!props.lock && <img
                                    className="drag-handle"
                                    style={{ height: "25px", width: 10, cursor: "move" }}
                                    onClick={() => showaddIcon && element.Name !== "Default" && setToggleEnable(true)}
                                    src={element.Name !== "Default" ? dragIcon : ""}
                                />}
                                {!props.lock && <div>
                                    {!removeValues && showaddIcon && <Icon
                                        type="edit"
                                        style={{ marginRight: "10px", fontSize: 15 }}
                                        onClick={() => {
                                            setAddEvent(
                                                (condition: any) => condition.map((c: any) => {
                                                    return c.id === element.id ? { ...element, blocks: false } : c
                                                }));
                                            findhandleId(index, element.id);
                                            setShowAddIcon(false)
                                            setShowCheckIcon(true)
                                            setshowEdit(false)
                                            setRemoveValues(true)
                                        }}
                                    />}
                                    {element.Name !== "Default" && showaddIcon && <Icon
                                        type="delete"
                                        style={{ marginRight: "10px", fontSize: 15 }}
                                        onClick={() => handleRemove(index, element.id)}
                                    ></Icon>}
                                    {<Icon
                                        style={{ fontSize: 15, marginRight: "10px" }}
                                        type="down"
                                        onClick={() => {
                                            setAddEvent(
                                                (condition: any) => condition.map((c: any) => {
                                                    return c.id === element.id && showaddIcon ? { ...element, expand: false } : c
                                                }))
                                        }} >
                                    </Icon>}
                                </div>}
                            </div>}
                        <div
                            style={{
                                border: ((!expand && !expandAll && showEdit)) ? "1px dashed #0F66C8" : "",
                                borderRadius: "8px",
                                padding: (expand || !expandAll && showEdit) ? 10 : !showEdit ? 10 : 0,
                                margin: ((!expand || !expandAll) && !blocks) ? 5 : 0
                            }}>
                            <div
                                key={index}
                                className={style.conditionInput}
                                style={{
                                    borderBottom: (!expand || !expandAll) && blocks && "1px solid 000610",
                                    margin: !expand && blocks ? 13 : 0,
                                    height: "auto",
                                    padding: (expand || !expandAll) ? "0 10px" : "0 15px",
                                    boxSizing: "border-box",
                                }}>

                                <div
                                    className={style.label}
                                    style={{ color: "#3c434a" }}
                                >
                                    <label >Handler Name</label>
                                </div>
                                <Input
                                    onKeyDown={handleSpace}
                                    disabled={blocks || props.lock || element.Name === "Default"}
                                    style={{
                                        width: "100%",
                                        outline: "none",
                                        height: "44px",
                                        color: "#000610",
                                        fontSize: 15,
                                        border: "1px solid #909BAD"
                                    }}
                                    placeholder="Enter Handler Name"
                                    value={element.Name || ""}
                                    onChange={(e) => { !checkSpecialCharacter.test(e.target.value) && handleName(e, index) }}
                                />
                                {(element.nameCheck || eventNameEmpty) &&
                                    <p style={{
                                        color: "#FF0000",
                                        opacity: element.nameCheck || eventNameEmpty ? 1 : 0,
                                        position: "relative",
                                        top: '15px',
                                        textAlign: "center"
                                    }}>{eventNameEmpty ? "Name shouldn't be empty" : "Name already exists"}</p>}

                                {element.Name !== "Default" && <div className={style.label} style={{ color: "#3c434a" }}>
                                    <label >Event Handler</label>
                                </div>}
                                {element.Name !== "Default" && <Input
                                    disabled={element.Name === "Default" || blocks || props.lock}
                                    style={{
                                        width: "100%",
                                        height: "44px",
                                        fontSize: "15px",
                                        cursor: element.Name === "Default" || blocks || props.lock ? "not allowed" : "pointer",
                                        color: "#000610",
                                        border: "1px solid #909BAD"
                                    }}
                                    autoComplete="off"
                                    onClick={() => { element.Name !== "Default" && openModal(); }}
                                    placeholder="Add Event Handler"
                                    value={element.handler || undefined}
                                />}
                                {modalOpen && !blocks && !props.lock &&
                                    <CodeEditor
                                        id={index}
                                        type="solo"
                                        values={element.handler}
                                        handleExpression={eventHandler}
                                        close={closeModal}
                                    />}
                                <div
                                    className={style.label}
                                    style={{ color: "#3c434a" }}
                                >
                                    <label >Next Node</label>
                                </div>
                                <Select
                                    showSearch
                                    suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                                    disabled={blocks || props.lock}
                                    value={element.linkNode || undefined}
                                    placeholder="Select the next node"
                                    optionLabelProp="label"
                                    style={{
                                        width: "100%",
                                        borderRadius: 8,
                                        color: "#000610",
                                        fontSize: 15
                                    }}
                                    mode="default"
                                    size="large"
                                    onChange={(e: any) => { linkNode(e, index) }}
                                    filterOption={(input, option: any) => {
                                        return (option && option.props)
                                            ?
                                            option.props.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            : false
                                    }}
                                >
                                    {nodes && nodes.map((el: any) => {
                                        return <Option
                                            key={el.id}
                                            value={el.id}
                                            label={el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                        >
                                            <div
                                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <div
                                                    style={{ display: "flex", flexDirection: "row" }}>
                                                    <img alt="icons" src={el.data.icon} />
                                                    <p
                                                        style={{
                                                            marginLeft: "8px",
                                                            marginTop: "15px",
                                                            color: el.id === element.linkNode ? "#0F66C8" : "#000610"
                                                        }}
                                                    >
                                                        {el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                                    </p>
                                                </div>
                                                {el.id === element.linkNode &&
                                                    < Icon type="check" style={{ color: "#0F66C8" }} />}
                                            </div>
                                        </Option>
                                    })}
                                </Select>
                                <div style={{ display: "flex", flexDirection: "row", marginTop: 15, justifyContent: "flex-end" }}>
                                    {!blocks && !props.lock &&
                                        <Button
                                            style={{ width: "30%", marginRight: showCheckIcon ? "15px" : "0px" }}
                                            onClick={() => {
                                                let findHandler = nodeDetail?.data?.propertyDetails?.eventHandler ? nodeDetail?.data?.propertyDetails?.eventHandler : nodeDetail?.data?.propertyDetails?.events
                                                   showEdit ?
                                                        handleRemove(index, element.id && element.id) : element.id &&
                                                       setAddEvent(findHandler.map((c: any) => {
                                                           return { 
                                                                ...c, 
                                                                Name: c.name || c.Name,
                                                                id: c.name || c.Name, 
                                                                blocks: true, 
                                                                linkNode: c?.next?.nodeId || c.linkNode
                                                            }
                                                        }));
                                                    if(element.id){
                                                        setShowCheckIcon(false);
                                                        setShowAddIcon(true)
                                                        setDisableExpand(false)
                                                        setshowEdit(true);
                                                        setEditEnable(false)
                                                        setRemoveValues(false);
                                                        setEventNameEmpty(false)
                                                    } else if(showEdit){
                                                        setShowCheckIcon(false);
                                                        setShowAddIcon(true)
                                                        setDisableExpand(false)
                                                        setshowEdit(true);
                                                        setEditEnable(false)
                                                        setRemoveValues(false);
                                                        setEventNameEmpty(false)
                                                    }else {
                                                        setEventNameEmpty(true)
                                                    }
                                            }}
                                        >CANCEL</Button>}
                                    {(!blocks && !props.nameCheck && !props.lock && !element.nameCheck && showCheckIcon) &&
                                        <Button
                                            style={{ width: "30%", border: "none", backgroundColor: "#F1722E" }}
                                            type="primary"
                                            onClick={() => {
                                                setAddEvent(
                                                    (condition: any) => {
                                                        const updatedCondition = condition.map((c: any) => {
                                                            return c.id === element.id ? { ...element, blocks: true, expand: false } : c
                                                        })
                                                        if (updatedCondition.length === 1) {
                                                            return updatedCondition;
                                                        }
                                                        if (showEdit) {
                                                            const defaultCondtion = updatedCondition.filter((condition: any) => { return (condition.Name === "Default") })
                                                            const newUpdatedCondition = updatedCondition.filter((condition: any) => { return (condition.Name !== "Default" && updatedCondition[0].id !== condition.id) })
                                                            return [...newUpdatedCondition, updatedCondition[0], ...defaultCondtion]
                                                        } else {
                                                            return updatedCondition
                                                        }
                                                    });
                                                setAddHandle(addHandle + 1);
                                                setShowAddIcon(true)
                                                setshowEdit(true);
                                                setDisableExpand(false)
                                                setEditEnable(false)
                                                if (showEdit) {
                                                    setUpdatedId(null)
                                                } else {
                                                    setRemoveValues(false)
                                                }
                                            }}
                                        >{showEdit ? "ADD" : "SAVE"}</Button>}
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>)
    }

    useEffect(() => {
        setReactSortableKey(new Date().getTime());
        setSortableOptions({ ...sortableOptions, disabled: !toggle });
    }, [toggle]);

    return (
        <div style={{ height: window.innerHeight - 500 }}>
            <div className={style.conditionInput}>
                <div style={{ width: "100%" }}>
                    <div
                        className={style.label}
                        style={{ color: "#3c434a" }}>
                        <label >
                           Event Name
                        </label>
                    </div>

                    {/* <Input
                        style={{
                            width: "100%",
                            height: "44px",
                            color: "#000610",
                            fontSize: 15,
                            border: props.nameCheck ? "1px solid #FF0000" : "1px solid #909BAD"
                        }}
                        placeholder="Enter Node Name"
                        value={name}
                        disabled={props.lock}
                        onChange={(e: any) => { setEventName(e.target.value); setName(e.target.value) }}
                    /> */}
                    <Select
                        style={{
                            width: "100%",
                            height: "44px",
                            color: "#000610",
                            fontSize: 15,
                        }}
                        size="large"
                        placeholder="Select Event"
                        value={eventName || undefined}
                        disabled={props.lock}
                        onChange={(e: any) => {setEventName(e); setName(e + " " + "event") }}
                    >
                    {eventsName.map((event: any) => {
                        return(
                         <Option
                            key={event.id}
                            value={event.name}
                        >
                            {event.name}
                            </Option>
                        )})}
                    </Select>
                </div>
                {(props.nameCheck || !name) && <p style={{
                    color: "#FF0000",
                    opacity: props.nameCheck || !name ? 1 : 0,
                    position: "relative",
                    textAlign: "center",
                    margin: "5px",
                    fontSize: 14
                }}>{!name ? "Name shouldn't be empty" : "Event already exists"}</p>}
            </div>
            <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
            <div className={style.conditionInput} style={{ paddingBottom: "16px", cursor: "pointer" }} onClick={(()=>{setEventNodeDrawer(true)})}>
                <div style={{color: "#052f35 ",fontWeight: 600, padding: "0px 10px", height: "36px", width: "100%", background: "rgba(0, 40, 85, 0.1)", borderRadius: "4px", alignItems: "center", justifyContent: "space-between" }} className={"flex"}>
                    <span>Access Control List Setup</span>
                    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 9.5L6.5 5L0.5 0.5" stroke="#052f35 " stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "0px 10px" }}>
                {expandAll ?
                    <button
                        //disabled={!disableExpand}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0px 14px",
                            borderRadius: 22,
                            border: "none",
                            outline: "none",
                            width: "35%",
                            cursor: "pointer",
                            background: "#F5F7FB 0% 0% no-repeat padding-box"
                        }}
                        onClick={() => {
                            !disableExpand && setAddEvent((prevState: any) => prevState.map((el: any) => ({
                                ...el,
                                expand: false
                            })))
                            !disableExpand && setExpandAll(false)
                        }}
                    >
                        <Icon style={{ fontSize: 15 }} type="folder" />
                        Collapse All
                    </button> :
                    <button
                        //disabled={}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0px 16px",
                            borderRadius: 22,
                            border: "none",
                            outline: "none",
                            width: "35%",
                            cursor: "pointer",
                            background: "#F5F7FB 0% 0% no-repeat padding-box"
                        }}
                        onClick={() => {
                            !disableExpand && showaddIcon && setAddEvent((prevState: any) => prevState.map((el: any) => ({
                                ...el,
                                expand: true
                            })))
                            !disableExpand && showaddIcon && setExpandAll(true)
                        }}
                    >
                        <Icon style={{ fontSize: 15 }} type="folder-open" />
                        Expand All
                    </button>}
                <Button
                    style={{ borderRadius: 22, backgroundColor: "#51808c", color: "white", border: "none", outline: "none" }}
                    disabled={props.lock || !showaddIcon || expandAll || props.nameCheck}
                    // icon="folder-add"
                    onClick={() => {
                        if (!props.lock) {
                            AddHandle();
                            setShowCheckIcon(false);
                            setShowAddIcon(false);
                            setDisableExpand(true);
                            setEditEnable(true);
                        }
                    }}
                    type="primary"
                >Add Handler
                </Button>
            </div>
            <div
                style={{ overflow: "auto", maxHeight: window.innerHeight - 360, border: "none", marginTop: "10px" }}>
                <ReactSortable list={addEvent} key={reactSortableKey} setList={(state: any) => {
                    const defaultValue = state.filter((value: any) => { return (value.Name === "Default") });
                    const other = state.filter((value: any) => { return (value.Name !== "Default") })
                    setAddEvent([...other, ...defaultValue])
                }} {...sortableOptions} onEnd={() => { setAddHandle(addHandle + 1) }}>
                    {addEvent.map((element: any, index: any) => {
                        const { blocks, expand } = element
                        return (
                            renderEvents(index, element, blocks, expand)
                        )
                    })}
                </ReactSortable>
            </div>
            {
                eventNodeDrawer ? <AclEventNodeDrawer eventProperty={eventProperty} setAclProperties={setAclProperties} getFlowDetails={props.getFlowDetails} nodeDetail={nodeDetail} flowDetail={props.flowDetail}  aclEventNodeData={eventProperty ? eventProperty : {}} onClose={(()=>{setEventNodeDrawer(false)})}></AclEventNodeDrawer> : null
            }
        </div >
    )
}
export default Event